import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import UI_ORGANIZATION_DETAILS_PAGE_QUERY, {
	type OrganizationDetailsOrganizationDetailsPageQuery,
} from '@jira/servicedesk__organization-details/src/__generated__/OrganizationDetailsOrganizationDetailsPageQuery.graphql.ts';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

const getCustomerServiceOrganizationAri = (
	organizationId: string,
	activationId: string,
): string => {
	return `ari:cloud:jira-servicedesk::organization/activation/${activationId}/${organizationId}`;
};

export const OrganizationDetailsPageQueryResource: RouteResource<
	PreloadedQuery<OrganizationDetailsOrganizationDetailsPageQuery, Record<string, unknown>>
> = createRelayResource<OrganizationDetailsOrganizationDetailsPageQuery>({
	type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: UI_ORGANIZATION_DETAILS_PAGE_QUERY,
		variables: {
			organizationId: getCustomerServiceOrganizationAri(
				String(match.params.organizationId),
				tenantContext.activationId,
			),
			cloudId: tenantContext.cloudId,
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
